<template>
  <div>
    <b-card bg-variant="warning">
      <h5 class="btm-zero">FBAから自動返送された商品を定期的にご確認いただき、以下のリストを随時更新お願いします。<a size="sm" :href="link()" target="_blank">　こちらのページでご確認いただけます。　</a></h5>
      <!-- <h5 class="btm-zero">（ 保管料：¥10、検品・清掃料：¥280、廃棄料：¥280 ）</h5> -->
    </b-card>
  </div>
</template>

<script>
export default {
  methods: {
    link() {
      return 'https://sellercentral-japan.amazon.com/ap/signin?openid.pape.max_auth_age=0&openid.return_to=https%3A%2F%2Fsellercentral-japan.amazon.com%2Fhome&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.assoc_handle=sc_jp_amazon_com_v2&openid.mode=checkid_setup&language=ja_JP&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&pageId=sc_jp_amazon_com_v2&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0&';
    },
  },
};
</script>

<style scoped>
a {
    text-decoration-line: underline;
    color: red;
    font-weight: bold;
}
.card > .card-body {
    padding: 1rem;
}
h5{
  font-size: 1rem;
}
.btm-zero {
    margin-bottom: 0;
}
</style>

